import { useFormikContext } from "formik";
import { Button, Form } from "react-bootstrap";
import { Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from "react";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import { OctGenerateForm } from "@oceantech/oceantech-ui";
import { generateInitValues } from "../../../../utils/AppFunction";
import { TypeKeHoach } from "../models/KeHoachModel";
import { AppContext } from "../../../../appContext/AppContext";

type Props = {
  LST_WAREHOUSE: any;
  listJsonGenerateVT?: any;
  generalValues: any;
  setGeneralFieldValue: any;
  indexRowEdit: number | null;
  setIndexRowEdit: Dispatch<SetStateAction<any>>;
  isView: boolean;
  warehouseId: number;
  type: TypeKeHoach;
  dsNhapKho: any[];
  setDsNhapKho: Dispatch<SetStateAction<any>>;
  initialValuesFormThemVT: any;
  setInitialValuesFormThemVT: Dispatch<SetStateAction<any>>;
};

const FormThemThongTinChuyenGiao = ({
  LST_WAREHOUSE,
  generalValues,
  listJsonGenerateVT,
  indexRowEdit,
  setIndexRowEdit,
  isView,
  warehouseId,
  type,
  dsNhapKho,
  setDsNhapKho,
  setGeneralFieldValue,
  initialValuesFormThemVT,
  setInitialValuesFormThemVT,
}: Props) => {

  const { setIsLoading } = useContext(AppContext);
  const {
    handleSubmit,
    handleChange,
    setValues,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormikContext<any>();
console.log(isView)
  return (
    <Form onSubmit={handleSubmit}>
      <OctGenerateForm
        isView={
          isView
        }
        listFieldAuto={listJsonGenerateVT}
        handleChange={handleChange}
        setValues={setValues}
        values={values}
        touched={touched}
        errors={errors}
        lstSelectedRenderButton={dsNhapKho}
        setFieldValue={setFieldValue}
        modelID={type.formVatTu}
        DynamicClass={"pl-38"}
        customComponent={DynamicComponent}
        warehouseId={warehouseId}
      />
      <div className="spaces mt-10">
        {(
          !isView
        ) &&
          <Button className="btn btn-fill spaces min-w-90" onClick={e => handleSubmit(values)}>
            {indexRowEdit === null ? `Thêm` : `Cập nhật`}
          </Button>
        }
      </div>
    </Form>
  );
};

export default FormThemThongTinChuyenGiao;
